import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IResponseError } from 'projects/common/src/app/interfaces/communication/response';
import { Observable, Subject } from 'rxjs';
import { CommunicationService } from 'src/app/services/communication';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class OperatorService {
  public operatorCreateEditSubject$ = new Subject<boolean>();
  private baseUrl: string;

  constructor(private communicationService: CommunicationService, private httpClient: HttpClient, private urlBuilder: UrlBuilderService) {
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   * Function to create Operator
   */
  public createOperator(params): Promise<IResponseError> {
    const url = `${this.baseUrl}/Operator/CreateOperator`;
    return this.communicationService.post(url, params).toPromise();
  }

  public editOperator(params): Promise<any> {
    let url = `${this.urlBuilder.apiUrl}/Operator/EditOperator?`;
    url += `OperatorId=${params.operatorId}`;
    url += `&FirstName=${params.firstName}`;
    url += `&LastName=${params.lastName}`;
    url += `&TagId=${params.tagId}`;
    url += `&SapNumber=${params.sapNumber}`;
    url += `&UserId=${params.userId}`;
    url += `&IsActive=${params.isActive}`;
    url += `&Comment=${params.comment}`;
    return this.httpClient.patch(url, params).toPromise();
  }

  /**
   * Search sap exists in operator table
   * @param sap
   * @returns
   */
  public searchSapOperator(sap: number): Promise<any> {
    const url = `${this.baseUrl}/Operator/GetSearchSap?SapNumber=${sap}`;
    return this.communicationService.get(url, sap).toPromise();
  }

  /**
   * Search tag exists in operator table
   */
  public searchTagOperator(tag: number): Promise<any> {
    const params = {
      searchTag: tag,
    };
    const url = `${this.baseUrl}/Operator/GetSearchTagOperator`;
    return this.communicationService.get(url, params).toPromise();
  }

  /**
   * Get all operators
   */
  public getAllOperators(): Promise<any> {
    const url = `${this.baseUrl}/Operator/GetAllOperator`;
    return this.communicationService.get(url).toPromise();
  }

  /**
   * obsCreateOperator()
   */
  public obsCreateEditEOperator(): Observable<boolean> {
    return this.operatorCreateEditSubject$.asObservable();
  }
}
